<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.33301 8.1333H9.99967"
      stroke="#A2A5B9"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.33301 10.7999H8.25301"
      stroke="#A2A5B9"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66634 4.00004H9.33301C10.6663 4.00004 10.6663 3.33337 10.6663 2.66671C10.6663 1.33337 9.99967 1.33337 9.33301 1.33337H6.66634C5.99967 1.33337 5.33301 1.33337 5.33301 2.66671C5.33301 4.00004 5.99967 4.00004 6.66634 4.00004Z"
      stroke="#A2A5B9"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 2.68005C12.8867 2.80005 14 3.62005 14 6.66672V10.6667C14 13.3334 13.3333 14.6667 10 14.6667H6C2.66667 14.6667 2 13.3334 2 10.6667V6.66672C2 3.62672 3.11333 2.80005 5.33333 2.68005"
      stroke="#A2A5B9"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "reports-icon",
};
</script>

<style lang="scss" scoped></style>
